import React from "react";

const Page = () => <>hi</>

export default Page;